"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const lib_1 = require("@brandfree-front/lib");
const mobx_react_1 = require("mobx-react");
const StoresUtil_1 = require("../util/StoresUtil");
let DataHandling = class DataHandling extends react_1.default.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    render() {
        const { translate } = this.translateStore;
        return (react_1.default.createElement(lib_1.Text, { className: "text-center" },
            react_1.default.createElement(lib_1.Grid, { align: ['center-xs'] },
                react_1.default.createElement(lib_1.GridColumn, { width: ['xs-12', 'md-10', 'lg-6'] },
                    react_1.default.createElement(lib_1.Text, null,
                        react_1.default.createElement(lib_1.Heading, { className: "h2" }, translate('gdpr.video.title')),
                        react_1.default.createElement("p", { className: "h4" }, translate('gdpr.video.info'))))),
            react_1.default.createElement(lib_1.Video, { className: "text__margin-double", position: "center", poster: {
                    srcset: 'https://i.vimeocdn.com/video/678025561.webp?mw=960&mh=540',
                    alt: 'Video image alt text'
                }, url: "https://player.vimeo.com/video/251612490", title: "Video title" })));
    }
};
DataHandling = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], DataHandling);
exports.default = DataHandling;
